import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-event-mgmt-comp',
  templateUrl: './event-mgmt-comp.component.html',
  styleUrls: ['./event-mgmt-comp.component.scss']
})
export class EventMgmtCompComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
